import { BtBackendProvider } from './../bt-backend/bt-backend';
import { AuthProvider } from './../auth/auth';

import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { User, Subscription } from '../../models/User';
import { Observable } from 'rxjs/Observable';
import { Promoter } from '../../models/FirstPromoter';

@Injectable()
export class UserProvider {

  constructor(
    private db: AngularFireDatabase,
    private auth: AuthProvider,
    private backend: BtBackendProvider
  ) {
    this.getSubscription().subscribe(sub => {
      if(sub){
        if(sub.refId == null || sub.refId == 'NONE'){
          let newRefId = this.getRefIdFromUrl();
          if(newRefId && newRefId != 'NONE'){
            this.setReferralCode(newRefId).subscribe(response =>{
            }, error => {
              console.log(error);
            })
          }
        }
      }
      //otherwise user is not logged in
    })
  }

  hasAccess(): Observable<boolean>{
    return this.getSubscription()
      .map(subscription => {
        if(subscription && subscription.status){
          return subscription.status == 'ACTIVE' || subscription.status === 'PRO';
        }else{
          return false;
        }
      })
      .catch((error, caught) => {
        return Observable.of(false);
      })
  }

  isLoggedIn(): boolean{
    return this.auth.authenticated;
  }

  isAdmin(): Observable<boolean>{
    return this.auth.getUserId()
      .switchMap(uid => {
        if(uid){
          return this.db
            .object(`admins`)
            .valueChanges()
            .map(keys => {
              for(let key in keys){
                if(key == uid) return true;
              }
              return false;
            })
            .catch((error, caught) => {
              return Observable.of(false);
            })
        }else{
          return Observable.of(false);
        }
      })

  }

  isPromoter(): Observable<boolean>{
    return this.getPromoter().map(promoter => {
      if(promoter) return true;
      else return false;
    })
  }

  getUser(): Observable<User>{
    return this.auth
      .getUserId()
      .switchMap(uid => {
        if(uid){
          const path = `users/${uid}`;
          let obj = this.db.object<User>(path);
          return obj.valueChanges().catch((error, caught) => {
            return Observable.of(null);
          })
        }else{
          return Observable.of(null);
        }
      })
  }

  getSubscription(): Observable<Subscription>{
    return this.auth
      .getUserId()
      .switchMap(uid => {
        if(uid){
          const path = `subscriptions/${uid}`;
          let obj = this.db.object<Subscription>(path);
          return obj.valueChanges().catch((error, caught) => {
            return Observable.of(null);
          })
        }else{
          return Observable.of(null);
        }
      })

  }

  getPromoter(): Observable<Promoter>{
    return this.auth
      .getUserId()
      .mergeMap(uid => {
        if(uid){
          const path = `promoters/${uid}`;
          let obj = this.db.object<Promoter>(path);
          return obj.valueChanges().catch((error, caught) => {
            return Observable.of(null);
          })
        }else{
          return Observable.of(null);
        }
      })
  }

  private getRefIdFromUrl(): string{
    let url = document.URL;
    return this.parseUrlForRefId(url);
  }

  public parseUrlForRefId(url: string): string{
    let splitURL = url.split("?");
    let splitParams;
    let refId: string;

    if(splitURL.length >= 2){
      splitParams = splitURL[1].split("&");
      for(let param of splitParams){
        let thisParam = param.split('=');
        if(thisParam.length == 2 && thisParam[0] == 'fp_ref'){
          refId = thisParam[1];
          //clean refId if anything has come after it - namely '#'
          if(refId.indexOf('#') > 0){
            refId = refId.substring(0, refId.indexOf('#'));
          }
          return refId;
        }
      }
    }
    return null;
  }

  public setReferralCode(ref): Observable<any>{
    return this.backend.setReferralId(ref).first();
  }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts